module.exports = __webpack_public_path__ + "img/icon_subscription_off.1006876e.svg";